import React from 'react'
import * as S from './styles'
import { MdxWrapperProps } from './types'

const MdxWrapper: React.FC<MdxWrapperProps> = ({ children, ...rest }) => (
  <S.Wrapper {...rest}>{children}</S.Wrapper>
)

export default MdxWrapper
